import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./talkingbook.styles.css";
import { motion, AnimatePresence } from "framer-motion";
import BookCard from "../../components/custom-components/bookCard/BookCard";
import SearchInput from "../../components/custom-components/SearchInput";
// import Button from '@mui/material/Button'
import { AppContext } from "../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";
import GetToken from "../../GetToken";
import { handleInvalidToken } from "../../AuthUtils";
import AnimationSpinner from '../../AnimationSpinner';
import { Card, Row, Col, Pagination, Form, Badge } from "react-bootstrap";
import Button from '@mui/material/Button';
import EmptyIcon from "../../assets/images/error-image.jpg"
import ErrorComponent from "../NoDataFound.jsx/NoError";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";

const BookList = () => {
    const tabsRef = useRef([]);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [tabUnderlineStyle, setTabUnderlineStyle] = useState({});
    const [items, setItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(8);
    const [totalItems, setTotalItems] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { base_url } = useContext(AppContext);
    const { book_type } = useParams();

    const [bookShareURL, setBookShareURL] = useState('');
    const [bookEmbedCode, setBookEmbedCode] = useState("");

    const [embedModalActive, setEmbedModalActive] = useState(false)
    const embedModalRef = useRef(null);


    const handleModelCloseClick = (event) => {
        if (event.target.classList.contains('history-image-model')) {
            closeModal();
        }
    };
    const closeModal = () => {
        setEmbedModalActive(false)
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (embedModalRef.current && !embedModalRef.current.contains(event.target)) {
                closeModal();
            }
        };
        if (setEmbedModalActive) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };


    }, [setEmbedModalActive]);

    const handleBookEmbedModalActive = (slug) => {
        var bookURL = '';
        if (book_type == 'talking_book') {
            bookURL = `${window.location.origin}/talking-book/${slug}`;

        } else if (book_type == 'flipbook') {
            bookURL = `${window.location.origin}/flipbook/${slug}`;

        } else {
            bookURL = `${window.location.origin}/photobook/${slug}`;
        }
        setEmbedModalActive(true);
        setBookEmbedCode(`<iframe src="${bookURL}" width="100%" height="600"></iframe>`);
        setBookShareURL(bookURL);
    }
    const allTabs = [
        { id: "talking_book", name: "Talking Books" },
        { id: "flipbook", name: "Flip Books" },
        { id: "photobook", name: "Photo Book Maker" },
    ];
    const handleBookDelete = async (ids) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            html: `<p>⚠️ <strong>This action is irreversible! Deleting this book will permanently remove all related data.</strong></p>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                const token = GetToken();
                if (!token) {
                    handleInvalidToken(navigate);
                    return;
                }
                setLoading(true)
                const formData = new FormData();
                formData.append("action", "removeBook");
                formData.append("token", token);
                formData.append("book_ids", ids);
                const response = await axios.post(
                    `${base_url}api/user/book`,
                    formData
                );

                if (response.data.status === true) {
                    fetchPageData();
                    toast.success("Your book has been deleted.");
                    // Swal.fire("Deleted!", "Your book has been deleted.", "success");
                    setLoading(false)
                } else {
                    setLoading(false)
                    if (response.data.reset === true) {
                        handleInvalidToken(navigate);
                        return;
                    }
                    toast.warning(response.data.message);
                    // Swal.fire({
                    //     icon: "warning",
                    //     title: "Warning",
                    //     text: response.data.message,
                    // });
                }
            } catch (error) {
                setLoading(false)
                toast.error("Failed to delete book");
                // Swal.fire("Error", "Failed to delete book", "error");
            }
        }
    };

    const toggleEnablePreview = async (slug, currentStatus) => {
        try {
            const newStatus = currentStatus == 1 ? 0 : 1;
            const token = GetToken();
            if (!token) {
                handleInvalidToken(navigate);
                return;
            }
            const formData = new FormData();
            formData.append("action", "toggleEnablePreview");
            formData.append("token", token);
            formData.append("book_token", slug);
            formData.append("enable_book_preview", newStatus);

            const response = await axios.post(`${base_url}api/user/book`, formData);
            if(response.data.status){
                fetchPageData() 
            }
            if (!response.data.status) {
                toast.warning(response.data.message);
                if (response.data.reset === true) {
                    handleInvalidToken(navigate);
                    return;
                }
            }
        } catch (error) {
            setLoading(false);
            toast.error("Failed to update preview status");
        }
    };


    const activeCategory = allTabs[activeTabIndex]?.id || "all";

    const fetchPageData = async () => {
        try {
            const token = GetToken();
            if (!token) {
                handleInvalidToken(navigate);
                return;
            }
            setLoading(true)
            const formData = new FormData();
            formData.append("action", "getBookLists");
            formData.append("token", token);
            formData.append("offset", currentPage);
            formData.append("limit", itemsPerPage);
            formData.append("search", searchTerm);
            formData.append("type", book_type);
            const response = await axios.post(
                `${base_url}api/user/book`,
                formData
            );

            if (response.data.status === true) {
                setItems(response.data.items || []);
                setTotalItems(response.data.totalItems || 0);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);

            } else {
                setLoading(false)
                if (response.data.reset === true) {
                    handleInvalidToken(navigate);
                    return;
                }
                toast.error(response.data.message);
                // Swal.fire({
                //     icon: "error",
                //     title: "Error",
                //     text: response.data.message,
                // });
            }

        } catch (error) {
            setLoading(false)
            toast.error(error.response?.data?.message ||
                error.message ||
                "Something went wrong. Please try again.");
            // Swal.fire({
            //     icon: "error",
            //     title: "Error",
            //     text:
            //         error.response?.data?.message ||
            //         error.message ||
            //         "Something went wrong. Please try again.",
            // });
        }
    };

    useEffect(() => {
        fetchPageData();
    }, [currentPage, navigate, searchTerm, itemsPerPage, activeTabIndex]);

    useEffect(() => {
        if (tabsRef.current[activeTabIndex]) {
            const { offsetLeft, offsetWidth } = tabsRef.current[activeTabIndex];
            setTabUnderlineStyle({ left: `${offsetLeft}px`, width: `${offsetWidth}px` });
        }
    }, [activeTabIndex]);

    const handleBookEdit = (slug) => {
        navigate('/book/edit/' + slug);
    };
    const handleReadBook = (slug) => {
        var bookURL = '';
        if (book_type == 'talking_book') {
            bookURL = `${window.location.origin}/talking-book/${slug}`;

        } else if (book_type == 'flipbook') {
            bookURL = `${window.location.origin}/flipbook/${slug}`;

        } else {
            bookURL = `${window.location.origin}/photobook/${slug}`;
        }
        if (bookURL) {
            window.open(bookURL, "_blank");
        }

    };


    const handleDownloadPhotoBook = async (slug) => {
        try {
            const token = GetToken();
            if (!token) {
                handleInvalidToken(navigate);
                return;
            }

            setLoading(true);

            const formData = new FormData();
            formData.append("action", "getDownloadPhotoBook");
            formData.append("token", token);
            formData.append("book_token", slug);

            const response = await axios.post(`${base_url}api/user/book`, formData);

            if (response.data.status === true) {
                const pdf = new jsPDF("p", "mm", "a4");

                for (let i = 0; i < response.data.bookContent.length; i++) {
                    if (i > 0) pdf.addPage();
                    const img = new Image();
                    img.src = response.data.bookContent[i].image_file;

                    await new Promise((resolve) => {
                        img.onload = () => {
                            const width = pdf.internal.pageSize.getWidth();
                            const height = (img.height * width) / img.width;
                            pdf.addImage(img, "PNG", 0, 10, width, height);
                            resolve();
                        };
                    });
                }

                pdf.save(slug + ".pdf");
                toast.success("Your PhotoBook has been downloaded successfully.");
                // Swal.fire({
                //     icon: "success",
                //     title: "Download Complete",
                //     text: "Your PhotoBook has been downloaded successfully.",
                // });

                setLoading(false);
            } else {
                setLoading(false);

                if (response.data.reset === true) {
                    handleInvalidToken(navigate);
                    return;
                }
                toast.warning(response.data.message);
                // Swal.fire({
                //     icon: "warning",
                //     title: "Warning",
                //     text: response.data.message,
                // });
            }
        } catch (error) {
            setLoading(false);
            toast.error("Failed to download book");
            // Swal.fire("Error", "Failed to download book", "error");
        }
    };

    const handleDownloadFlipBook = async (fileUrl, slug) => {
        try {
            setLoading(true);

            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${slug}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
            toast.success("Your book has been downloaded successfully.");
            // Swal.fire({
            //     icon: "success",
            //     title: "Download Complete",
            //     text: "Your book has been downloaded successfully.",
            // });

        } catch (error) {
            toast.error("Failed to download the PDF. Please try again.");
            // Swal.fire({
            //     icon: "error",
            //     title: "Download Failed",
            //     text: "Failed to download the PDF. Please try again.",
            // });
        }
    };

    const handleDownloadTalkingBook = async (slug) => {
        try {
            const token = GetToken();
            if (!token) {
                handleInvalidToken(navigate);
                return;
            }

            setLoading(true);

            const formData = new FormData();
            formData.append("action", "getDownloadTalkingBook");
            formData.append("token", token);
            formData.append("book_token", slug);

            const response = await axios.post(`${base_url}api/user/book`, formData);

            if (response.data.status === true) {
                const { book, bookContent, bookContentPagesDetail } = response.data;

                if (!book || !bookContent || !bookContentPagesDetail) {
                    setLoading(false);
                    toast.warning("Book details are incomplete.");
                    // Swal.fire({
                    //     icon: "warning",
                    //     title: "Warning",
                    //     text: "Book details are incomplete.",
                    // });
                    return;
                }

                const pdf = new jsPDF();

                if (book.cover_image) {
                    const img = new Image();
                    img.src = book.cover_image;
                    img.onload = () => {
                        pdf.addImage(img, "PNG", 10, 10, 190, 250);
                        pdf.addPage();
                        generateBookContent();
                    };
                } else {
                    generateBookContent();
                }

                const generateBookContent = () => {
                    const stripHtml = (html) => {
                        let doc = new DOMParser().parseFromString(html, "text/html");
                        return doc.body.textContent || "";
                    };

                    bookContent.forEach((chapter, index) => {
                        pdf.setFontSize(16);
                        pdf.text(chapter.chapter_title, 10, 20);

                        const pages = bookContentPagesDetail.filter(
                            (page) => page.book_content_ids === chapter.ids
                        );

                        let yPosition = 40;

                        pages.forEach((page, pageIndex) => {
                            let plainText = stripHtml(page.content);
                            let wrappedText = pdf.splitTextToSize(plainText, 250);

                            if (pageIndex === 0) {
                                pdf.setFontSize(12);
                                pdf.text(wrappedText, 10, yPosition);
                                yPosition += wrappedText.length * 7;
                            } else {
                                pdf.addPage();
                                yPosition = 20;
                                pdf.setFontSize(12);
                                pdf.text(wrappedText, 10, yPosition);
                                yPosition += wrappedText.length * 7;
                            }
                        });

                        if (index < bookContent.length - 1) {
                            pdf.addPage();
                        }
                    });




                    pdf.save(`${slug}.pdf`);
                    toast.success("Your Talking Book has been downloaded successfully.");
                    // Swal.fire({
                    //     icon: "success",
                    //     title: "Download Complete",
                    //     text: "Your Talking Book has been downloaded successfully.",
                    // });

                    setLoading(false);
                };
            } else {
                setLoading(false);

                if (response.data.reset === true) {
                    handleInvalidToken(navigate);
                    return;
                }
                toast.warning(response.data.message);
                // Swal.fire({
                //     icon: "warning",
                //     title: "Warning",
                //     text: response.data.message,
                // });
            }
        } catch (error) {
            setLoading(false);
            toast.error("Failed to download book");
            // Swal.fire("Error", "Failed to download book", "error");
        }
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const copyText = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => toast.success('Copied to clipboard!'))
            .catch(err => console.error("Failed to copy link: ", err));
    };

    useEffect(() => {
        switch (book_type) {
            case 'talking_book':
                setActiveTabIndex(1);
                break;
            case 'flipbook':
                setActiveTabIndex(2);
                break;
            case 'photobook':
                setActiveTabIndex(3);
                break;
            default:
                navigate('/dashboard');
                break;
        }
    }, [book_type]);


    return (
        <div className="container p-0">
            {embedModalActive && (
                <div
                    className="history-image-model embed-modal shadow rounded position-absolute"
                    ref={embedModalRef}
                    onClick={handleModelCloseClick}
                >
                    <motion.div
                        className="model-body position-relative"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.3 }}
                    >

                        <div className="d-flex justify-content-between mb-2 btn-container gap-2 text-white py-2" style={{ width: "94%" }}>
                            <h4 className="text-dark fw-semibold">Embed Modal</h4>
                            <Button
                                className="btn btn-sm btn-primary text-white"
                                style={{ zIndex: "1", height: "35px" }}
                                onClick={closeModal}
                            >
                                <MdClose />
                            </Button>
                        </div>

                        <div className="row mx-4" style={{ marginTop: "70px" }}>
                            <div className="mb-3">
                                <label>
                                    <p>Book URL</p>
                                </label>
                                <textarea
                                    className="form-control custom-form-control mb-3"
                                    defaultValue={bookShareURL}
                                    rows={20}
                                    style={{ height: "70px" }}
                                    disabled
                                />
                                <div className="row justify-content-end ps-3">
                                    <Button variant="contained" color="secondary" style={{width: "50px"}} onClick={() => copyText(bookShareURL)} >Copy</Button>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label>
                                <p>Embed Book</p>
                                </label>
                                <textarea
                                    className="form-control custom-form-control mb-3"
                                    defaultValue={bookEmbedCode}
                                    rows={20}
                                    style={{ height: "70px" }}
                                    disabled
                                />
                                <div className="row justify-content-end ps-3">
                                    <Button variant="contained" color="secondary" style={{width: "50px"}} onClick={() => copyText(bookEmbedCode)}>Copy</Button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
            <AnimationSpinner show={loading} />

            <div className="right-container">
                <div className="row align-items-center">
                    <div className="col-lg-6 page-title-container">
                        <h4 className="fw-semibold mb-1">
                            {book_type === 'talking_book' ? 'Talking Books' :
                                book_type === 'flipbook' ? 'Flip Books' :
                                    book_type === 'photobook' ? 'Photo Books' :
                                        'Talking Books'}
                        </h4>
                        <p className="mb-1">
                            {book_type === 'talking_book' ? 'Manage All Talking Books Here' :
                                book_type === 'flipbook' ? 'Manage All Flip Books Here' :
                                    book_type === 'photobook' ? 'Manage All Photo Books Here' :
                                        'Manage All Talking Books Here'}
                        </p>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end">
                        <SearchInput searchTerm={searchTerm} setSearchTerm={setSearchTerm} borderColor="var(--primary-color)" />
                    </div>
                </div>
                <div className="container-fluid p-0">
                    <div className="book-library">
                        {/* Book Grid with Zoom-In and Zoom-Out Animation */}
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={activeCategory}
                                className="row g-4"
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.95 }}
                                transition={{ duration: 0.2 }}
                            >
                                {items.length > 0 ? (
                                    items.map((book) => (
                                        <motion.div
                                            key={book.ids}
                                            className="col-12 col-sm-6 col-md-4 col-lg-3 "
                                            initial={{ opacity: 0, scale: 0.95 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.95 }}
                                            transition={{ duration: 0.2 }}
                                        >
                                            <BookCard handleBookEmbedModalActive={handleBookEmbedModalActive} book={book} handleBookDelete={handleBookDelete} handleBookEdit={handleBookEdit} book_type={book_type} handleReadBook={handleReadBook} handleDownloadPhotoBook={handleDownloadPhotoBook} handleDownloadFlipBook={handleDownloadFlipBook} toggleEnablePreview={toggleEnablePreview} handleDownloadTalkingBook={handleDownloadTalkingBook} />
                                        </motion.div>
                                    ))
                                ) : (
                                    <motion.div
                                        className="text-center w-100"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <ErrorComponent image={EmptyIcon} description={"No books available"} />

                                    </motion.div>
                                )}
                            </motion.div>
                        </AnimatePresence>
                        {totalPages> 1 && (
                            <div className="pagination-container mt-4 w-full d-flex justify-content-center align-items-center border-top pt-4">
                                <Pagination className="mb-0">
                                    <Pagination.Prev
                                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                    />
                                    {[...Array(totalPages)].map((_, index) => (
                                        <Pagination.Item
                                            key={index + 1}
                                            active={index + 1 === currentPage}
                                            onClick={() => setCurrentPage(index + 1)}
                                        >
                                            {index + 1}
                                        </Pagination.Item>
                                    ))}
                                    <Pagination.Next
                                        onClick={() =>
                                            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                                        }
                                        disabled={currentPage === totalPages}
                                    />
                                </Pagination>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookList;
